import { Compiler, ViewContainerRef, Injector, NgModuleFactory, Type } from '@angular/core';
import { of } from 'rxjs/observable/of';
import { finalize } from 'rxjs/operators/finalize';
import { ConfigService } from '@finder/core/config.service';
import { CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import { loadScriptResource, loadCssResource } from '@finder/shared/utils/utils.dom';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/config.service";
import * as i2 from "./tokens";
import * as i3 from "@angular/common";
export class LazyLoaderService {
    constructor(config, compiler, injector, lazyBundles, document) {
        this.config = config;
        this.compiler = compiler;
        this.injector = injector;
        this.lazyBundles = lazyBundles;
        this.document = document;
        this.cdnBaseUrl = '';
        this.resourceRegistry = new Set();
        this.env = this.config.getValue(CONFIG_CONSTANTS.envKey);
        if (this.env !== CONFIG_CONSTANTS.developmentEnv) {
            const cdnList = config.getValue(CONFIG_CONSTANTS.cdnListKey);
            const cdnPath = config.getValue(CONFIG_CONSTANTS.cdnPathKey);
            const cdnDomain = cdnList && cdnList.length > 0 ? cdnList[0] : '';
            this.cdnBaseUrl = cdnDomain + cdnPath;
        }
        else {
            this.cdnBaseUrl = '/';
        }
    }
    lazyLoadCssResource(src) {
        // Check to make sure we don't add the same src over and over
        if (this.resourceRegistry.has(src)) {
            return;
        }
        // Add to registry
        this.resourceRegistry.add(src);
        // Add src to doc
        loadCssResource(this.document, this.cdnBaseUrl + src);
    }
    lazyLoadScriptResource(src) {
        // Check to make sure we don't add the same src over and over
        if (this.resourceRegistry.has(src)) {
            return of(true);
        }
        // Add src to doc
        return loadScriptResource(this.document, this.cdnBaseUrl + src)
            .pipe(finalize(() => {
            // Add to registry
            this.resourceRegistry.add(src);
        }));
    }
    lazyLoadModule(name, container, data = {}) {
        return this.lazyBundles[name]().then(tempModule => {
            if (tempModule instanceof NgModuleFactory) {
                // For AOT
                return createComponent(tempModule, this.injector);
            }
            else {
                // For JIT
                return this.compiler
                    .compileModuleAsync(tempModule)
                    .then(factory => {
                    return createComponent(factory, this.injector);
                });
            }
        });
        function createComponent(moduleFactory, injector) {
            const entryComponent = moduleFactory.moduleType.entry;
            const moduleRef = moduleFactory.create(injector);
            const compFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(entryComponent);
            // if there is no container param just return the
            // component factory
            if (!container) {
                return compFactory;
            }
            const componentRef = container.createComponent(compFactory, null, moduleFactory.injector);
            Object.assign(componentRef.instance, data);
            return componentRef;
        }
    }
}
LazyLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LazyLoaderService_Factory() { return new LazyLoaderService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i0.Compiler), i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i2.LAZY_MODULES), i0.ɵɵinject(i3.DOCUMENT)); }, token: LazyLoaderService, providedIn: "root" });
